import { Box, Card, CardContent, Typography, Stack, Divider, Stepper, Step, StepLabel, Button } from '@mui/material'
import { Case } from '../../types'
import { themeColors } from '../../app/layout/theme'
import { CASE_STATUS } from '../../constants'

interface CaseDetailProps {
  caseRecord: Case
  onStatusChange?: (status: string) => void
  onEdit?: () => void
}

export const CaseDetail = ({ caseRecord, onStatusChange, onEdit }: CaseDetailProps) => {
  const statusIndex = CASE_STATUS.indexOf(caseRecord.status)

  return (
    <Box sx={{ padding: 3 }}>
      <Stack spacing={3}>
        <Card sx={{ backgroundColor: themeColors.surface }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Case Status
            </Typography>
            <Stepper activeStep={statusIndex} sx={{ mb: 2 }}>
              {CASE_STATUS.map((status) => (
                <Step key={status}>
                  <StepLabel>{status}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </CardContent>
        </Card>

        <Card sx={{ backgroundColor: themeColors.surface }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Case Details
              </Typography>
              {onEdit && (
                <Button variant="outlined" size="small" onClick={onEdit}>
                  Edit
                </Button>
              )}
            </Box>
            <Stack spacing={2}>
              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Case Number
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.caseNumber}
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Subject
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.subject}
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Status
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.status}
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Priority
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.priority}
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Contact
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.contactName || 'N/A'}
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Account
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.accountName || 'N/A'}
                </Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="body2" sx={{ color: themeColors.text.secondary }}>
                  Owner
                </Typography>
                <Typography sx={{ color: themeColors.text.primary }}>
                  {caseRecord.owner}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  )
}
